import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from '../../../cmsHooks/useIndexPageData'

import { SectionHeader } from '../../ui'
import { FullWidthSection, ContentContainer } from '../../layout'
import PartnerBox from './why/PartnerBox'
import Reason from './why/Reason'
import device from '../../../utilities/device'

const WhyLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  @media ${device.laptop} {
    flex-direction: column;
    p {
      font-size: 20px;
    }
  }
  @media ${device.mobileL} {
    flex-direction: column;
    p {
      font-size: 18px;
    }
  }
`
const Column = styled.div`
  flex-basis: 42%;
  @media ${device.laptop} {
    max-width: 80%;
    margin: 0 auto;
  }
  @media ${device.mobileL} {
    max-width: 90%;
  }
  @media ${device.mobileM} {
    max-width: 98%;
  }
`
const VertCenterColumn = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: 45%;
`
const StyledReason = styled(Reason)`
  margin-bottom: 30px;
  @media ${device.laptop} {
    margin-bottom: 0px;
  }
`

const WhySection = (): JSX.Element => {
  const data = useIndexPageData()

  return (
    <FullWidthSection lightGray>
      <ContentContainer>
        <WhyLayout>
          <Column>
            <SectionHeader>
              <CMS.Text name="Why headline" data={data} />
              <CMS.Text name="Product name" data={data} />?
            </SectionHeader>
            <Reason number={1} />
            <Reason number={2} />
            <StyledReason number={3} />
          </Column>
          <VertCenterColumn>
            <PartnerBox />
          </VertCenterColumn>
        </WhyLayout>
      </ContentContainer>
    </FullWidthSection>
  )
}

export default WhySection
